import goals from "../../../../src/components/content/goals/m6";
import * as React from 'react';
export default {
  goals,
  React
};